import { render, staticRenderFns } from "./data-distrik.vue?vue&type=template&id=85d04aac"
import script from "./data-distrik.vue?vue&type=script&lang=js"
export * from "./data-distrik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports